import React, { useState } from 'react';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import PlusIcon from '@mui/icons-material/Add';
import Stack from '@mui/material/Stack';

import LeadForm from './LeadForm';

const CreateLeadDialog = props => {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="md">
      <DialogContent>
        <Stack direction='row' justifyContent='flex-end' spacing={1} alignItems='center'>
          <IconButton
            onClick={props.onClose}
          >
            <CloseIcon />
          </IconButton>
        </Stack> 
        <LeadForm 
          editing={false}
          afterSubmit={e => props.onClose()}
          isAdmin={props.isAdmin}
        />
      </DialogContent>
    </Dialog>
  );
};

const CreateLeadButton = props => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box>
      <CreateLeadDialog 
        open={isOpen}
        onClose={() => setIsOpen(false)}
        afterCreate={props.afterCreate || null}
        isAdmin={props.isAdmin || false}
      />
      <Button size={props?.size} variant='contained' color='success' onClick={() => setIsOpen(true)}>
        <PlusIcon />{' '}
        New
      </Button>
    </Box>
  );
};

export default CreateLeadButton;